import request from '@/utils/request'


// 查询手型号列表
export function listJoe(query) {
  return request({
    url: '/joe/watch-models/list',
    method: 'get',
    params: query
  })
}

export function changeIsOpen(data) {
  return request({
    url: '/joe/watch-models/changeIsOpen',
    method: 'post',
    data: data
  })
}

// 查询手型号分页
export function pageJoe(query) {
  return request({
    url: '/joe/watch-models/page',
    method: 'get',
    params: query
  })
}

// 查询手型号详细
export function getJoe(data) {
  return request({
    url: '/joe/watch-models/detail',
    method: 'get',
    params: data
  })
}

// 新增手型号
export function addJoe(data) {
  return request({
    url: '/joe/watch-models/add',
    method: 'post',
    data: data
  })
}

// 修改手型号
export function updateJoe(data) {
  return request({
    url: '/joe/watch-models/edit',
    method: 'post',
    data: data
  })
}

// 删除手型号
export function delJoe(data) {
  return request({
    url: '/joe/watch-models/delete',
    method: 'post',
    data: data
  })
}
